"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.afcMatch = void 0;
const plugin_audio_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-audio-multi-response"));
const __1 = require("../../..");
const taskSetup_1 = require("../../taskSetup");
const helpers_1 = require("../../shared/helpers");
const trials_1 = require("../../shared/trials");
const taskStore_1 = require("../../../taskStore");
const helpers_2 = require("../../shared/helpers");
const components_1 = require("../../shared/helpers/components");
const displayDebugInfo_1 = require("../../shared/helpers/displayDebugInfo");
let selectedCards = [];
let selectedCardIdxs = [];
let previousSelections = [];
let startTime;
const replayButtonHtmlId = 'replay-btn-revisited';
const SELECT_CLASS_NAME = 'info-shadow';
const generateImageChoices = (choices) => {
    return choices.map((choice) => {
        const imageUrl = __1.mediaAssets.images[(0, helpers_1.camelize)(choice)];
        return `<img src=${imageUrl} alt=${choice} />`;
    });
};
function enableBtns(btnElements) {
    btnElements.forEach((btn) => btn.removeAttribute('disabled'));
}
function cleanAttributes(attributes) {
    const nonWhiteBackgrounds = ['gray', 'striped', 'black'];
    // add in the background string if it's not there (white background)
    if (!attributes.some((item) => nonWhiteBackgrounds.includes(item))) {
        attributes.push('white');
    }
    if (!attributes.some((item) => !isNaN(Number(item)))) {
        attributes.splice(3, 0, '1');
    }
    return attributes;
}
// First check amongst the selections if they all share one trait
// Second check if any previous selections used those EXACT same selections
// At least one selection must be different from previous selections
// (also, ignore any specified dimension -- some blocks now don't vary particular dimensions)
function compareSelections(selections, previousSelections, ignoreDims) {
    const dimensionIndices = {
        size: 0,
        color: 1,
        shape: 2,
        number: 3,
        bgcolor: 4,
    };
    // Check if all selections share at least one common trait (ignoring specified dimensions)
    function sharedTrait(selections, ignoreDims) {
        const sets = {};
        // Initialize sets for each non-ignored dimension
        for (const [dim, index] of Object.entries(dimensionIndices)) {
            if (!ignoreDims.includes(dim)) {
                sets[dim] = new Set();
            }
        }
        // Populate sets with values from selections
        for (const sel of selections) {
            const attributes = cleanAttributes(sel.split('-'));
            for (const [dim, set] of Object.entries(sets)) {
                const index = dimensionIndices[dim];
                if (attributes[index] !== undefined) {
                    set.add(attributes[index]);
                }
            }
        }
        // Check if any non-ignored dimension has all the same values
        return Object.values(sets).some((set) => set.size === 1);
    }
    // Check if any selection is different from all previous selections
    function hasNewSelection(selections, previousSelections) {
        // If there are no previous selections, every current selection is considered new
        if (!previousSelections || previousSelections.length === 0) {
            return true;
        }
        let hasNewSelection = true;
        previousSelections.forEach((item) => {
            // check that most recent selection does not have the same cards as a previous selection (even in reverse)
            if ((selections[0] === item[0] && selections[1] === item[1]) ||
                (selections[1] === item[0] && selections[0] === item[1])) {
                hasNewSelection = false;
            }
        });
        return hasNewSelection;
    }
    // Perform checks
    const traitShared = sharedTrait(selections, ignoreDims);
    const containsNew = hasNewSelection(selections, previousSelections);
    return traitShared && containsNew;
}
function getIgnoreDims(stim) {
    if (stim.trialType === 'something-same-2') {
        return ['number', 'bgcolor'];
    }
    else if (stim.trialType === '2-match') {
        return ['number', 'bgcolor'];
    }
    else {
        return ['size'];
    }
}
const afcMatch = (trial) => {
    return {
        type: plugin_audio_multi_response_1.default,
        data: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            let isPracticeTrial = stim.assessmentStage === 'practice_response';
            return {
                save_trial: stim.trialType !== 'instructions',
                assessment_stage: stim.assessmentStage,
                // not for firekit
                isPracticeTrial: isPracticeTrial,
            };
        },
        stimulus: () => {
            return __1.mediaAssets.audio.nullAudio;
        },
        prompt: () => {
            const stimulus = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const prompt = (0, helpers_1.camelize)(stimulus.audioFile);
            const t = (0, taskStore_1.taskStore)().translations;
            return `<div class="lev-stimulus-container">
        ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
        <div class="lev-row-container instruction">
          <p id="afc-match-prompt">${t[prompt]}</p>
        </div>
      </div>`;
        },
        prompt_above_buttons: true,
        button_choices: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            if (stim.assessmentStage === 'instructions') {
                return ['OK'];
            }
            else {
                const randomize = !!stim.answser ? 'yes' : 'no';
                // Randomize choices if there is an answer
                const { choices } = (0, helpers_1.prepareChoices)(stim.answer, stim.distractors, randomize);
                return generateImageChoices(choices);
            }
        },
        button_html: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const buttonClass = stim.assessmentStage === 'instructions' ? 'primary' : 'image-medium';
            return `<button class="${buttonClass}">%choice%</button>`;
        },
        on_load: () => {
            var _a, _b;
            // create img elements and arrange in grid as cards
            // on click they will be selected
            // can select multiple cards and deselect them
            startTime = performance.now();
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const isPractice = stim.assessmentStage === 'practice_response';
            const audioFile = stim.audioFile;
            const audioConfig = {
                restrictRepetition: {
                    enabled: false,
                    maxRepetitions: 2,
                },
            };
            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[(0, helpers_1.camelize)(audioFile)], audioConfig);
            const pageStateHandler = new helpers_1.PageStateHandler(audioFile, true);
            (0, helpers_1.setupReplayAudio)(pageStateHandler);
            (0, helpers_1.addExperimenterButtons)();
            (0, helpers_1.setupFullscreenButton)();
            const buttonContainer = document.getElementById('jspsych-audio-multi-response-btngroup');
            const responseBtns = Array.from(buttonContainer.children)
                .map((btnDiv) => btnDiv.firstChild)
                .filter((btn) => !!btn);
            let numberOfErrors = 0;
            if (stim.trialType !== 'instructions') {
                if ((0, taskStore_1.taskStore)().version === 2) {
                    // insert progress indicator
                    const numbers = {
                        first_response: 1,
                        second_response: 2,
                        third_response: 3,
                        fourth_response: 4,
                    };
                    const currentResponse = numbers[stim.assessmentStage];
                    const maxResponses = Number(stim.trialType[0]);
                    if (currentResponse !== undefined) {
                        const progressContainer = document.createElement('div');
                        progressContainer.className = 'sds-progress-container';
                        progressContainer.innerHTML = `
              ${components_1.sdsProgressComponentFilled.repeat(currentResponse)} ${components_1.sdsProgressComponentEmpty.repeat(maxResponses - currentResponse)}
            `;
                        progressContainer.style.marginTop = '32px';
                        (_a = buttonContainer.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(progressContainer, buttonContainer.nextSibling);
                    }
                    // Add primary OK button under the other buttons
                    const okButton = document.createElement('button');
                    okButton.className = 'primary';
                    okButton.textContent = 'OK';
                    okButton.style.marginTop = '16px';
                    okButton.disabled = true;
                    okButton.addEventListener('click', () => {
                        if (!isPractice || compareSelections(selectedCards, previousSelections, getIgnoreDims(stim))) {
                            numberOfErrors = 0;
                            taskSetup_1.jsPsych.finishTrial();
                        }
                        else {
                            const prompt = document.getElementById('afc-match-prompt');
                            prompt.textContent = `${(0, taskStore_1.taskStore)().translations.feedbackNotQuiteRight} ${(0, taskStore_1.taskStore)().translations[(0, helpers_1.camelize)(audioFile)]}`;
                            numberOfErrors++;
                            const numberOfErrorsThisCall = numberOfErrors;
                            const audioConfig = {
                                restrictRepetition: {
                                    enabled: false,
                                    maxRepetitions: 2,
                                },
                                onEnded: () => {
                                    if (numberOfErrorsThisCall === numberOfErrors) {
                                        // don't overlap audio
                                        helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[(0, helpers_1.camelize)(audioFile)]);
                                    }
                                },
                            };
                            helpers_1.PageAudioHandler.stopAndDisconnectNode();
                            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.feedbackNotQuiteRight, audioConfig);
                            responseBtns.forEach((btn) => btn.classList.remove(SELECT_CLASS_NAME));
                            selectedCards = [];
                            (0, helpers_1.disableOkButton)();
                            if (numberOfErrors >= 2) {
                                let animationStarted = false;
                                const selections = responseBtns.map((btn) => { var _a; return (_a = btn === null || btn === void 0 ? void 0 : btn.firstChild) === null || _a === void 0 ? void 0 : _a.alt; });
                                for (let i = 0; i < selections.length; i++) {
                                    if (animationStarted) {
                                        break;
                                    }
                                    const firstSelection = selections[i];
                                    for (let j = i + 1; j < selections.length; j++) {
                                        const secondSelection = selections[j];
                                        if (compareSelections([firstSelection, secondSelection], previousSelections, ['number', 'bgcolor'])) {
                                            responseBtns[i].style.animation = 'pulse 2s infinite';
                                            responseBtns[j].style.animation = 'pulse 2s infinite';
                                            animationStarted = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    });
                    (_b = buttonContainer.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(okButton, buttonContainer.nextSibling);
                }
                if (responseBtns.length === 5) {
                    // 3 x 2 button layout
                    buttonContainer.classList.add('lev-response-row-inline', 'grid-3x2');
                }
                else {
                    // linear button layout
                    buttonContainer.classList.add('lev-response-row', 'multi-4');
                }
                responseBtns.forEach((card, i) => card.addEventListener('click', async (e) => {
                    var _a;
                    const answer = (_a = card === null || card === void 0 ? void 0 : card.firstChild) === null || _a === void 0 ? void 0 : _a.alt;
                    if (!card) {
                        return;
                    }
                    if (card.classList.contains(SELECT_CLASS_NAME)) {
                        card.classList.remove(SELECT_CLASS_NAME);
                        selectedCards.splice(selectedCards.indexOf(answer), 1);
                        selectedCardIdxs.splice(selectedCardIdxs.indexOf(i), 1);
                    }
                    else {
                        card.classList.add(SELECT_CLASS_NAME);
                        selectedCards.push(answer);
                        selectedCardIdxs.push(i);
                    }
                    if ((0, taskStore_1.taskStore)().version === 2) {
                        if (selectedCards.length === stim.requiredSelections) {
                            (0, helpers_1.enableOkButton)();
                        }
                        else {
                            (0, helpers_1.disableOkButton)();
                        }
                    }
                    else {
                        const requiredSelections = stim.requiredSelections;
                        if (selectedCards.length === requiredSelections) {
                            setTimeout(() => taskSetup_1.jsPsych.finishTrial(), 500);
                        }
                    }
                    setTimeout(() => enableBtns(responseBtns), 500);
                }));
            }
            (0, displayDebugInfo_1.displayDebugInfo)(stim);
        },
        response_ends_trial: () => {
            return (trial || (0, taskStore_1.taskStore)().nextStimulus).trialType === 'instructions' && (0, taskStore_1.taskStore)().version === 2;
        },
        on_finish: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const cat = (0, taskStore_1.taskStore)().runCat;
            const endTime = performance.now();
            const calculatedRt = endTime - startTime;
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            // save data
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                corpusTrialType: stim.trialType,
                answer: stim.answer || null,
                response: selectedCards,
                distractors: stim.distractors,
                item: stim.item,
                rt: Math.round(calculatedRt),
                audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
                responseLocation: selectedCardIdxs,
                itemUid: stim.itemUid,
                audioFile: stim.audioFile,
                corpus: (0, taskStore_1.taskStore)().corpus,
            });
            if ((0, taskStore_1.taskStore)().storeItemId) {
                taskSetup_1.jsPsych.data.addDataToLastTrial({
                    itemId: stim.itemId,
                });
            }
            if (stim.audioFile.split('-')[2] === 'prompt1') {
                // Prompt 1 is the start and prompt 2 trials are when the selections
                // Must be different from previous selections
                previousSelections = [];
            }
            const isCorrect = compareSelections(selectedCards, previousSelections, getIgnoreDims(stim));
            // update task store
            (0, taskStore_1.taskStore)('isCorrect', isCorrect);
            if (isCorrect === false) {
                taskStore_1.taskStore.transact('numIncorrect', (oldVal) => oldVal + 1);
            }
            else {
                (0, taskStore_1.taskStore)('numIncorrect', 0);
            }
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                correct: isCorrect,
            });
            previousSelections.push(selectedCards);
            selectedCards = [];
            selectedCardIdxs = [];
            if (stim.assessmentStage === 'test_response') {
                taskStore_1.taskStore.transact('testTrialCount', (oldVal) => oldVal + 1);
            }
            // if heavy instructions is true, show data quality screen before ending
            if ((0, taskStore_1.taskStore)().numIncorrect >= (0, taskStore_1.taskStore)().maxIncorrect && !(0, taskStore_1.taskStore)().heavyInstructions && !cat) {
                (0, trials_1.finishExperiment)();
            }
            if (cat) {
                (0, helpers_1.shouldTerminateCat)();
                (0, helpers_2.updateTheta)(stim, isCorrect);
                const allSequentialTrials = (0, taskStore_1.taskStore)().sequentialTrials;
                const nextTrials = allSequentialTrials.filter((trial) => {
                    return trial.trialNumber === stim.trialNumber && trial.trialType === stim.trialType;
                });
                (0, helpers_1.selectNextSequentialTrial)(nextTrials);
            }
        },
    };
};
exports.afcMatch = afcMatch;
